/* eslint-disable react/jsx-no-target-blank */
import { object, string, number, bool, func } from "prop-types";
import React, { useState, useEffect } from "react";
import { getCurrencySymbolFromCode } from "../../../../../utils/constants";
// import { Link } from "react-router-dom";
//import createDOMPurify from 'dompurify'
//import { JSDOM } from 'jsdom'

const LoadingMessage = () => {
  const [index, setIndex] = useState(0);
  const messages = [
    "Reading your career history... 📄",
    "Extracting key skills... 💡",
    "Comparing qualifications with role requirements... 🔍",
    "Synthesizing match score... 🧠",
    "Almost there! Adding final touches... ✨",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((old) => (old + 1) % messages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <span style={{ color: "#3A6ED4", fontSize: "14px", fontWeight: "600" }}>
      {messages[index]}
    </span>
  );
};

const ViewDetails = ({
  job,
  section,
  matchScore,
  matchRecommendation,
  matchLoading,
  matchError,
  onCalculateMatch,
}) => {
  // Helper function to get color based on match score
  const getScoreColor = (score) => {
    if (score >= 80) return "#28a745"; // Green
    if (score >= 60) return "#ffc107"; // Yellow
    if (score >= 40) return "#fd7e14"; // Orange
    return "#dc3545"; // Red
  };

  return (
    <div className="">
      {section === "documents" && (
        <div className="pb-5">
          {job.additional_files && job.additional_files[0] ? (
            <div className="d-flex flex-column">
              {job.additional_files.map((fileLink, index) => (
                <a
                  className="doc-link bg-primary mid-radius py-3 my-2 w-100"
                  key={index.toString()}
                  target="_blank"
                  href={fileLink}
                >
                  <b>{fileLink}</b>
                </a>
              ))}
            </div>
          ) : (
            <span>No Additional documents</span>
          )}
        </div>
      )}

      {section === "details" && (
        <div>
          {/* Match Score Section */}
          {/* <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "20px",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "12px",
              }}
            >
              <h5 style={{ margin: 0 }}>Job Match Score</h5>
              {matchScore === null && !matchLoading && (
                <button
                  onClick={onCalculateMatch}
                  style={{
                    backgroundColor: "#3A6ED4",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    padding: "6px 12px",
                    cursor: "pointer",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Check Match 🤖
                </button>
              )}
            </div>

            {matchLoading ? (
              <div style={{ padding: "10px 0" }}>
                <div style={{ textAlign: "center", marginBottom: "15px" }}>
                  <LoadingMessage />
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#adb5bd",
                      marginTop: "8px",
                    }}
                  >
                    AI analysis can take up to 30 seconds to be thorough.
                  </p>
                </div>
                <div
                  style={{
                    height: "6px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "3px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <div
                    className="loading-bar-pulse"
                    style={{
                      height: "100%",
                      width: "60%",
                      backgroundColor: "#3A6ED4",
                      borderRadius: "3px",
                    }}
                  />
                </div>
                <style>{`
                  @keyframes loading-pulse {
                    0% { transform: translateX(-100%); width: 30%; }
                    50% { width: 60%; }
                    100% { transform: translateX(400%); width: 30%; }
                  }
                  .loading-bar-pulse {
                    animation: loading-pulse 2s infinite ease-in-out;
                  }
                `}</style>
              </div>
            ) : matchError ? (
              <div style={{ color: "#dc3545", fontSize: "14px" }}>
                {matchError}
              </div>
            ) : matchScore !== null ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "32px",
                      fontWeight: "bold",
                      color: getScoreColor(matchScore),
                      marginRight: "12px",
                    }}
                  >
                    {Math.round(matchScore)}%
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        height: "10px",
                        backgroundColor: "#e9ecef",
                        borderRadius: "5px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          height: "100%",
                          width: `${matchScore}%`,
                          backgroundColor: getScoreColor(matchScore),
                          transition: "width 0.3s ease",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {matchRecommendation && (
                  <p
                    style={{
                      margin: 0,
                      marginTop: "10px",
                      fontSize: "14px",
                      color: "#495057",
                      lineHeight: "1.5",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>AI Recommendation:</strong> {matchRecommendation}
                  </p>
                )}
              </div>
            ) : (
              <p style={{ margin: 0, fontSize: "14px", color: "#6c757d" }}>
                Click the button to see how well you match this role. 
              </p>
            )}
          </div> */}

          <div>
            <h5>Reports To</h5>
            <p>{job.reports_to}</p>
          </div>
          {job.about_hiring_manager && (
            <div>
              <h5 style={{ paddingTop: "15px" }}>About Hiring Manager</h5>
              <p>{job.about_hiring_manager}</p>
            </div>
          )}
          <div>
            <h5 style={{ paddingTop: "15px" }}>About the company</h5>

            <p>
              {/* <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.about_company) }}></span> */}
              {
                <span
                  dangerouslySetInnerHTML={{
                    __html: job.about_company || job.about_role,
                  }}
                ></span>
              }
            </p>
          </div>
          <div>
            <h5>Applicants Benefits</h5>
            <p>{job.applicant_benefit}</p>
          </div>
          {job.salary_range ? (
            <div>
              <h5>Salary</h5>
              <p>{getCurrencySymbolFromCode(job.currency || "USD")} {job.salary_range}</p>
            </div>
          ) : (
            ""
          )}
          <div>
            <h5>Skills Required</h5>
            <ul className="d-flex flex-wrap mt-3">
              {job.skills_required && job.skills_required[0] && (
                <>
                  {job.skills_required.map((skill, index) => (
                    <li
                      key={index.toString()}
                      className="mr-2 py-1 px-2 mt-1 outlined"
                    >
                      {skill}
                    </li>
                  ))}
                </>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

ViewDetails.propTypes = {
  job: object.isRequired,
  section: string.isRequired,
  matchScore: number,
  matchRecommendation: string,
  matchLoading: bool,
  matchError: string,
  onCalculateMatch: func,
};

export default ViewDetails;
